import React from "react";
import {
  DialogContent,
  CardContent,
  Card,
  TableContainer,Table,TableRow,TableBody
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import TableBodyCell from "components/table/TableBodyCell";

export const BankDetailsModel = (props) => {
  const { visible, callbackEvent} = props;
  const babkDetails = props.data
  
  return (
    <Spin>
      <KisshtDialog
        title={"Bank Details"}
        maxWidth={"md"}
        open={visible}
        handleClose={callbackEvent}
      >
        <DialogContent>
          <Card>
            <CardContent>
              <TableContainer style={{border:"solid 0.6px gray"}}>
              <Table striped className="cust-2-tab" style={{borderCollapse:"separate", borderSpacing : "0", width:"100%"}}>
                <TableBody>
                <TableRow>
                    <TableBodyCell className="font-semibold" >Account Holder Name	</TableBodyCell>
                    <TableBodyCell>{babkDetails.bank_account_holder_name || "-"}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="font-semibold" >Account No</TableBodyCell>
                    <TableBodyCell>{babkDetails.bank_account_no || "-"}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="font-semibold" >Bank Name	</TableBodyCell>
                    <TableBodyCell>{babkDetails.bank_name || "-"}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="font-semibold" >Bank Branch	</TableBodyCell>
                    <TableBodyCell>{babkDetails.bank_branch || "-"}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="font-semibold" >IFSC Code	</TableBodyCell>
                    <TableBodyCell>{babkDetails.bank_ifsc_code || "-"}</TableBodyCell>
                  </TableRow>
                </TableBody>
                </Table>
              </TableContainer> 
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};

export default BankDetailsModel;
